import { JSONSchema7 } from 'json-schema';
import { types as commonTypes } from '@sitebuilder/common';
import ReferenceComponent from './ReferenceComponent';

const schema: JSONSchema7 = {
    title: 'Reference Component',
    type: 'object',
    required: [],
    properties: {
        referenceId: {
            type: 'string',
            description: 'Reference Id',
            default: '',
        },
        isPublicRefComponent: {
            type: 'boolean',
            description: 'Is Public Component',
            default: false,
        },
    },
};

const ReferenceComponentWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        styles: {
            'ui:widget': 'CSSEditor',
        },
        referenceId: {
            'ui:widget': 'ResourcePicker',
        },
        isPublicRefComponent: { 'ui:widget': 'CustomCheckbox' },
    },
    templateView: ReferenceComponent,
    id: 'ReferenceComponent',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default ReferenceComponentWidget;
